<template>
<div>

    <div v-if="spinner" class="spinner-grow spinner-grow-sm text-warning"   role="status">
        <span class="sr-only">Loading...</span>
    </div>
  <div class="d-flex align-items-center">

 
              <button
                  v-if="!disabled"
                  :disabled="disabled"
                  title = 'Ricarica colori'
                  class = "btn btn-light"
                  type  = "button"
                  @click="getData()"
                >
                  <i style="color:black" class='fas fa-sync'></i>
                </button>

            <v-select
                class="flex-fill"
              
              
                
                :options="availableColors()"
                label="name"
                :disabled="disabled"

                :reduce="color => color.id"
                v-model="colorId"
                placeholder="Seleziona colore"
                @input="onColorSelect(colorId)"
                :append-to-body="true"                
                
                >  

                  <template #search="{attributes, events}" >
                    <input
                      class="vs__search"
                      :required="!colorId"
                      v-bind="attributes"
                      v-on="events"
                    />
                  </template>
            </v-select>
           
</div>             
</div>
</template>
<script>

import api from '@/api'
import vSelect from 'vue-select';
import 'vue-select/dist/vue-select.css'


import { mapGetters }   from 'vuex';
  export default {
    props:['vIndex','variants','Id','colors','disabled'],

    components:{vSelect},
    
    data () {
      return {
        
        items        : [],
        spinner      : false,
        colorId      : null

        
      }
    },
  
     computed: 
  {
    ...mapGetters(['company']) , 
    
 
  },

    created () 
    {
       
      // this.getData()
      this.colorId = this.Id  
    },

    methods: 
    {
      
      setPreviousColor(Id)
      {
        this.colorId = Id
      },
      onColorSelect(colorId)
      {

        const colorMap = Object.fromEntries(
             this.colors.map(c => [c.id, c.name])
        )
       
        const color = colorMap[colorId]
        this.$emit('update',colorId,this.vIndex,color)
      },

      availableColors() {
      //return this.colors  
      const vIndex = this.vIndex  
      const usedIds = this.variants
        .filter((v, i) => i !== vIndex && v.colorId !== null)
        .map(v => v.colorId)
        return this.colors.filter(c => !usedIds.includes(c.id))
    },
      
      async getData()
      {
        this.spinner    = true
        const sp        = {'sp':'spColorListNew'}
         const data     = {
            "companyId"    : this.company.Id,        
        }
        const json      = Object.assign(data, sp)
        
        await api.post(json).then(res => {
          if(res.status==200)
            {
             
              //this.colors  =  res.data.recordsets[0]
              const colors =   res.data.recordsets[0]                   
              this.$emit('setColors',colors)
            }
            else if(res.status==500)
            {
              console.log(res.data)

            } 
            else
            {
              console.log('Network Error.')                  
            } 
        }).catch(err => 
        {
          console.log(err.message)    
        }).finally(() => {
          this.spinner = false
        });
        
      },  

    }
  }
</script>
<style scoped>

.w-100 {
  width: 100% !important;
}

.vs__dropdown-menu {
  z-index: 1050; /* sopra Bootstrap modals */



}




</style>
